<template>
	<div class="bg-white">
		<router-view />
	</div>
</template>
